import dayjs from "dayjs";
import { Event } from "../Event"

export class SituationEvents extends Event {
    public onLoad = (value: any, setField: any, setState: any, formValues: any) => {
        if (this.globalProps.match.url.includes('/add')) {
            this.setFieldValue("situation_active", true);
        }
    };
}